/**
 * SCRUM-249 (WH-7) — Zod schemas for the property-level pricing provider HTTP
 * boundary (DS-017 §12.1).
 *
 * Endpoints covered:
 *   POST   /organizations/:slug/properties/:propertyId/pricing/provider        ConnectPropertyToProvider
 *   DELETE /organizations/:slug/properties/:propertyId/pricing/provider         DisconnectPropertyFromProvider (no body → 204)
 *   POST   /organizations/:slug/properties/:propertyId/pricing/provider/sync    TriggerManualProviderSync (no body → 202)
 *
 * ConnectPropertyToProvider returns the saga-light envelope
 * { status: 200 | 400 | 500 }; the controller maps 200→201, 400→502, 500→500
 * and emits only the sanitized success body below (NEVER the raw `reason`).
 *
 * Adversarial tests: packages/validators/src/__tests__/pricing/provider-sync.spec.ts
 */
import { z } from 'zod';
import { ProviderKindSchema } from './provider-connection.js';
// ---------------------------------------------------------------------------
// ConnectPropertyToProviderRequestSchema — POST body
// ---------------------------------------------------------------------------
/**
 * The org-level connection supplies the credentials; this per-property connect
 * only selects which already-connected provider to attach. organizationId /
 * propertyId / actorUserId come from the request context + path, never the body.
 */
export const ConnectPropertyToProviderRequestSchema = z
    .object({
    providerKind: ProviderKindSchema,
})
    .strict();
// ---------------------------------------------------------------------------
// Response schemas
// ---------------------------------------------------------------------------
/**
 * 201 success body for ConnectPropertyToProvider. `providerListingId` is the
 * provider-facing listing handle the client owns. On 502/500 the controller
 * returns a generic exception body and does NOT echo this field or the raw
 * envelope `reason`.
 */
export const ConnectPropertyToProviderResponseSchema = z.object({
    providerListingId: z.string().min(1),
});
/**
 * 202 Accepted body for TriggerManualProviderSync — the deterministic ingest
 * job id (FE poll handle) + the provider-facing listing string.
 */
export const TriggerManualProviderSyncResponseSchema = z.object({
    jobId: z.string().min(1),
    providerListingId: z.string().min(1),
});
//# sourceMappingURL=provider-sync.js.map